import './Home.css';
import Header from '../../components/main/header/Header.jsx';
import Main from '../../components/main/middle/Main.jsx';

function Home() {
  return(
    <>
      <Header />
      <Main />
    </>
  )
}


export default Home;